import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-header-bg shadow-sm border-b border-border">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <img
              src="/recit-logo.png"
              alt="Recit Logo"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-text-primary hover:text-primary font-medium transition-colors">
              Home
            </Link>
            <a
              href="https://go.recit.sg/s"
              className="text-text-primary hover:text-primary font-medium transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Marketplace
            </a>
            <Link to="/terms" className="text-text-primary hover:text-primary font-medium transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="text-text-primary hover:text-primary font-medium transition-colors">
              Privacy
            </Link>
          </nav>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              variant="ghost"
              className="text-text-primary hover:text-primary font-medium"
              onClick={() => window.location.href = 'https://go.recit.sg/login'}
            >
              Login
            </Button>
            <Button
              className="bg-primary hover:bg-primary/90 text-white font-semibold rounded-lg px-6 py-2 shadow-md hover:shadow-lg transition-all duration-300"
              onClick={() => window.location.href = 'https://go.recit.sg/signup/customer'}
            >
              Sign Up
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-text-primary hover:text-primary"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-border">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-text-primary hover:text-primary font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <a
                href="https://go.recit.sg/s"
                className="text-text-primary hover:text-primary font-medium transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Marketplace
              </a>
              <Link
                to="/terms"
                className="text-text-primary hover:text-primary font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Terms
              </Link>
              <Link
                to="/privacy"
                className="text-text-primary hover:text-primary font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Privacy
              </Link>
              <div className="flex flex-col space-y-3 pt-4 border-t border-border">
                <Button
                  variant="outline"
                  className="w-full border-border text-text-primary hover:bg-muted"
                  onClick={() => {
                    window.location.href = 'https://go.recit.sg/login';
                    setMobileMenuOpen(false);
                  }}
                >
                  Login
                </Button>
                <Button
                  className="w-full bg-primary hover:bg-primary/90 text-white rounded-lg"
                  onClick={() => {
                    window.location.href = 'https://go.recit.sg/signup/customer';
                    setMobileMenuOpen(false);
                  }}
                >
                  Sign Up
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;